import React, { useState } from "react";
import { StyledEngineProvider } from "@mui/material";
import "../ui/widgets/loader/styles.scss";
import { FullScreenLoadingOverlay } from "../ui/widgets/loader";

export interface LoadingContextApi {
  overlayActive: boolean;
  setOverlayActive: (active: boolean) => void;
}

export const LoadingContext = React.createContext({
  overlayActive: false,
} as LoadingContextApi);

export const LoadingContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [overlayActive, setOverlayActive] = useState(false);

  return (
    <StyledEngineProvider injectFirst>
      <LoadingContext.Provider value={{ overlayActive, setOverlayActive }}>
        <FullScreenLoadingOverlay loading={overlayActive} />
        {children}
      </LoadingContext.Provider>
    </StyledEngineProvider>
  );
};
